import CloseIcon from "@mui/icons-material/Close";
import { Grid, Box } from "@mui/material";
import { useDrag, useDrop } from "react-dnd";

import "./element.scss";
import images from "../../../../assets/images";


interface DynamicElementHOCProps {
  children?: React.ReactNode;
  onRemove?: () => void;
  showRemove?: boolean;
  className?: string;
}

const DynamicElementHOC = (props: DynamicElementHOCProps) => {
  const [, ref] = useDrag({
    type: "element",
    item: { index: props.index },
  });
  const [, drop] = useDrop({
    accept: "element",
    hover: (draggedElement: any) => {
      const draggedIndex = draggedElement.index;
      const dropIndex = props.index;
      if (dropIndex === draggedIndex) {
        return;
      }

      props.swap(draggedIndex, dropIndex);
    },
    drop: () => {
      props.elementSwap();
    },
  });

  
  const activeClassName = `${
    props.activeIndex
      ? "form-element-wrapper--Active"
      : "form-element-wrapper--Element"
  }`;
  const defaultClassName = `${
    props?.children?.props?.typeOfField === "custom"
      ? ""
      : "form-element-wrapper--Default"
  }`;

  return (
    <Grid
      item
      xs={props?.element === "table" ? 12 : 12}
      className={`${activeClassName} ${defaultClassName}`}
      ref={(node) => drop(ref(node))}
    >
      <Box sx={{ width: "100%" }} onClick={props.onClick}>
        {props.children}
      </Box>
      <div className="form-element-wrapper--Actions">
        <img
          src={images.duplicate}
          onClick={() => props.handleDuplicate(props.index)}
        />
        {props?.children?.props?.typeOfField === "custom" && (
          <CloseIcon
            style={{ fontSize: "1rem", color: "#656669" }}
            onClick={() => {
              props.removeElement(props.index);
              props.setElementHoc();
            }}
          />
        )}
      </div>
    </Grid>
  );
};
export { DynamicElementHOC };
export default DynamicElementHOC;
